import React from 'react';

import ThumbsUp from '@atlaskit/icon/core/thumbs-up';
import { token } from '@atlaskit/tokens';

export const ThumbIcon = ({ isSelected }: { isSelected: boolean }): React.JSX.Element => (
	<ThumbsUp
		color={isSelected ? token('color.icon.selected') : token('color.icon.subtle')}
		label=""
	/>
);
